// A strategy's lifecycle, from the status the server sends on every pool
// (GET /txns/pools, GET /txns/pool/:id). "active" takes new investment;
// "winding_down" is still listed but off the leaderboards; "closed" is
// unlisted and only reachable by its holders. The server refuses to invest
// in anything but an active pool (POOL_NOT_ACTIVE); these checks keep the
// site from offering it.

export const STATUS_LABEL = {
  active: "Active",
  winding_down: "Winding down",
  closed: "Closed",
};

export const CLOSED_TO_INVESTMENT = "Closed to new investment";

/** The pool's status, or null when it has none. */
export const statusOf = (pool) => pool?.status ?? null;

/** Only an active pool can be invested in; no status is not active. */
export const canInvest = (pool) => statusOf(pool) === "active";

/** Strategy lists show everything but closed pools. */
export const isListed = (pool) => statusOf(pool) !== "closed";

/** Leaderboards show neither closed nor winding-down pools. */
export const isOnLeaderboard = (pool) =>
  statusOf(pool) !== "closed" && statusOf(pool) !== "winding_down";

/** True for an absolute http(s) URL -- the only kind rendered as a link. */
export const isHttpUrl = (value) => {
  if (typeof value !== "string") return false;
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};
